<template>
  <div class="document">
    <document-header :account="celebration.name" description="Comprovante<br>de Estorno"></document-header>
    <div class="container">
      <div class="row row-wrap">
        <div class="col-6">
          <div class="item-box">
            <div class="item-box-header"><h4>Cliente</h4></div>
            <div class="item-box-content">
              <h5>CPF/CNPJ</h5>
              {{ customer.document | documentMasked }}
              <h5>Nome</h5>
              {{ customer.name }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="item-box">
            <div class="item-box-header"><h4>Experiência</h4></div>
            <div class="item-box-content">
              <div class="row">
                <div class="col">
                  <h5>CPF/CNPJ</h5>
                  {{ celebration.document | documentMasked }}
                </div>
                <div class="col">
                  <h5>Conta Heppi</h5>
                  {{ celebration.heppiAccount }}
                </div>
              </div>
              <h5>Nome</h5>
              {{ celebration.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="item-box mt-4">
        <div class="item-box-header"><h3>Detalhes do Estorno</h3></div>
        <div class="item-box-content">
          <div>
            <div class="row my-3" v-for="item in items" :key="item.heppiReference">
              <div class="col">
                Item: {{ item.item }}
                <br />
                Fatura: {{ item.heppiReference }}
                <br />
                Total: {{ item.amount | price }}
              </div>
              <div class="col">
                Cartão: {{ item.paymentMethod }}
                <br />
                Parcelas: {{ item.installments }}x de {{ (item.amountPaid / item.installments) | price }}
                <br />
                Status: {{ item.status }}
              </div>
            </div>
          </div>
          <hr class="my-3" />
          <div class="row">
            <div class="col-auto pa-5 text-uppercase">
              <h5>Realizado em</h5>
              <div class="text-bold">
                {{ date | moment('DD MMM YYYY') }}
              </div>
            </div>
            <div class="col pa-5">
              <h5>Motivo</h5>
              {{ description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import documentHeader from '@/components/documentHeader'

export default {
  name: 'chargeback',
  components: {
    documentHeader
  },
  data () {
    return {
      customer: {
        name: 'Alícia Eduarda Rios Soares',
        document: '07116507566'
      },
      celebration: {
        name: 'Baile de Formatura - Medicina Ufal 2515',
        heppiAccount: '84994891-1',
        document: '11296408000179'
      },
      items: [
        {
          item: '1x Garçom',
          paymentMethod: 'MASTERCARD terminado em 6365',
          installments: 12,
          amount: 300.00,
          amountPaid: 333.75,
          heppiReference: '69642fe7162d063eb300d964',
          gatewayId: 'CFE57A80-D1F2-4F57-A628-42D755722860',
          status: 'Estornado'
        }
      ],
      date: '2026-01-15',
      description: 'Fez um pagamento duplicado no cartão'
    }
  },
  created () {
    document.title = 'Comprovante de Estorno - ' + this.celebration.name + ' - ' + this.customer.name + ' - ' + this.$moment(this.date).format('DD-MM-YYYY')
  }
}
</script>
